import { PayrollToCastingQueryApi } from '@lib/api/endpoints';
import { setDisplayI9Indicators } from '@lib/redux.lib/slices/projects/projectsSlice';
import { AppDispatch } from '@lib/redux.lib/store';
import { logIfDevelopment } from '@lib/utils/logging';

export const getDisplayI9Indicators = async (
  castingProjectId?: number,
  dispatch?: AppDispatch,
  isEnabledOnExplorePage?: boolean
) => {
  if (isEnabledOnExplorePage) {
    dispatch(setDisplayI9Indicators(true));
    return;
  }
  const handleDispatchDisplayI9Indicators = (displayI9Indicators: boolean) => {
    dispatch(setDisplayI9Indicators(displayI9Indicators));
  };
  try {
    if (!castingProjectId) {
      handleDispatchDisplayI9Indicators(false);
      return;
    }
    const displayI9Indicators = await PayrollToCastingQueryApi.getDisplayI9Indicators(castingProjectId);
    handleDispatchDisplayI9Indicators(displayI9Indicators.display_i9_indicators);
  } catch (error) {
    logIfDevelopment(error);
    handleDispatchDisplayI9Indicators(false);
  }
};
